// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const InlinedRequestBody = {
    properties: (value) => {
        return {
            value: value,
            type: "properties",
            _visit: function (visitor) {
                return FernIr.dynamic.InlinedRequestBody._visit(this, visitor);
            },
        };
    },
    referenced: (value) => {
        return Object.assign(Object.assign({}, value), { type: "referenced", _visit: function (visitor) {
                return FernIr.dynamic.InlinedRequestBody._visit(this, visitor);
            } });
    },
    fileUpload: (value) => {
        return Object.assign(Object.assign({}, value), { type: "fileUpload", _visit: function (visitor) {
                return FernIr.dynamic.InlinedRequestBody._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "properties":
                return visitor.properties(value.value);
            case "referenced":
                return visitor.referenced(value);
            case "fileUpload":
                return visitor.fileUpload(value);
            default:
                return visitor._other(value);
        }
    },
};
